/** The reader's motion preference as a live query, for a script that must also hear it change. */
export const reducedMotionQuery = (): MediaQueryList =>
	window.matchMedia("(prefers-reduced-motion: reduce)");

/** True when the reader has asked for less motion. The one copy; three existed before. */
export const prefersReducedMotion = (): boolean => reducedMotionQuery().matches;

/** The one predicate behind both halves: whether the registry fetches a motion-gated chunk, and
    whether `markJsReady` arms the hidden states only that chunk clears. Two readings can disagree. */
export const allowsMotion = (): boolean => !prefersReducedMotion();
